// @ts-nocheck
import { IconPresentationProps } from "@insite/mobius/Icon";
import { LinkPresentationProps } from "@insite/mobius/Link";
// import { linkActionStyles, linkIconStyles } from "@store/Themes/common/mixins/link"; // Store Custom Code
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { css } from "styled-components";

/* Store Custom Code - Start */
import getColor from "@insite/mobius/utilities/getColor";
import { linkActionStyles, linkIconStyles, linkStyles } from "@store/Themes/common/mixins/link";
import { visuallyHiddenStyles } from "@toolkit/Themes/common/mixins/common";
/* Store Custom Code - End */

export const linkGetIconProps = (
    src: IconPresentationProps["src"],
    position: "right" | "left" = "left",
    size?: IconPresentationProps["size"] | string,
): LinkPresentationProps["icon"] => ({
    position,
    iconProps: {
        src,
        color: "inherit",
        css: linkIconStyles(typeof size === "number" ? pxToRem(size) : size),
    },
});

export const linkGetActionLinkProps = (
    src?: IconPresentationProps["src"],
    position: "right" | "left" = "left",
    size?: IconPresentationProps["size"] | string,
): LinkPresentationProps => ({
    icon: linkGetIconProps(src, position, size),
    css: css`
        ${linkActionStyles()}
        align-items: flex-start;
    `,
});

/* Store Custom Code - Start */
export const linkGetIconOnlyLinkProps = (
    src: IconPresentationProps["src"],
    size: IconPresentationProps["size"] = 24,
    linkSize: string = pxToRem(36),
): LinkPresentationProps => ({
    icon: {
        iconProps: {
            src,
            size,
            color: "inherit",
            css: css`
                margin: 0;
            `,
        },
    },
    typographyProps: {
        css: visuallyHiddenStyles(),
    },
    css: css`
        ${linkStyles("text", "secondary", false, false)}
        align-items: center;
        justify-content: center;
        width: ${linkSize};
        height: ${linkSize};
        background-color: ${getColor("common.accent")};
        border-radius: 50%;
    `,
});
/* Store Custom Code - End */
